import './App.scss'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { router } from './router'
import { useAuthStore } from './store'
import { autoTranslateDirective } from '@/utils/autoTranslateDirective'
import '@/utils/language-picker.js'
import tolgee from '@/utils/tolgee'
import {
  init as SentryInit,
  browserTracingIntegration,
  captureConsoleIntegration,
  dedupeIntegration,
  replayIntegration,
} from '@sentry/vue'
import { VueTolgee } from '@tolgee/vue'
import BalmUI from 'balm-ui'
import 'balm-ui-css'
import BalmUIPlus from 'balm-ui-plus'
import { createPinia, storeToRefs } from 'pinia'
import { createApp } from 'vue'

// Vue i18n is temporarily disabled during the Tolgee migration.
// // @ts-ignore
// import en from './locales/en.js'
// // @ts-ignore
// import fr from './locales/fr.js'
// import { createI18n } from 'vue-i18n'
//
// const i18n = createI18n({
//   locale: 'en',
//   legacy: false,
//   globalInjection: true,
//   messages: {
//     en,
//     fr,
//   },
// })

const language = window.document.documentElement.lang

const app = createApp(App)

app
  .use(vuetify)
  .use(BalmUI)
  .use(BalmUIPlus)
  .use(VueTolgee, { tolgee })
  // .use(i18n)
  .use(createPinia())
  .use(router)
  .directive('auto-translate', autoTranslateDirective)
  .mixin({
    methods: {
      $t(value: string) {
        return value
      },
      money(value: string, currency = '') {
        const { profile } = storeToRefs(useAuthStore())

        return parseFloat(value).toLocaleString([language, 'en-NG'], {
          currency: currency || profile.value?.owner?.currency || 'NGN',
          style: 'currency',
        })
      },
      formatDate(date: string | number | Date) {
        return new Date(date).toDateString()
      },
      formatDateTime(date: string | number | Date) {
        return new Date(date).toUTCString()
      },
      shrinkText(value: string, size = 100) {
        if (value.length > size) {
          return value.substring(0, size) + '...'
        }
        return value
      },
    },
  })

SentryInit({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    browserTracingIntegration({ router }),
    replayIntegration(),
    captureConsoleIntegration({ levels: ['error', 'warn'] }),
    dedupeIntegration(),
  ],
  environment: import.meta.env.VITE_APP_ENV,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

app.mount('#app')
